// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { brewSensorySessionStatus } from './BrewSensorySessionStatus';
import { brewBatchId } from './BrewBatch';
import { brewSampleId } from './BrewSample';
import { operatorId } from './Operator';
import { brewSensoryTemplateId } from './BrewSensoryTemplate';
import { brewSensoryFormId } from './BrewSensoryForm';
import { z } from 'zod';
export const brewSensorySessionId = (z.number());
export const brewSensorySession = z.object({
    id: brewSensorySessionId,
    name: z.string().nullable(),
    status: brewSensorySessionStatus,
    aroma_enabled: z.boolean(),
    taste_enabled: z.boolean(),
    reference_brew_batch_id: brewBatchId.nullable(),
    reference_brew_sample_id: brewSampleId.nullable(),
    planned_date: z.date().nullable(),
    instructions: z.string().nullable(),
    activated_at: z.date().nullable(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    source_template_id: brewSensoryTemplateId.nullable(),
    aroma_form_id: brewSensoryFormId.nullable(),
    taste_form_id: brewSensoryFormId.nullable(),
});
export const brewSensorySessionInitializer = z.object({
    id: brewSensorySessionId.optional(),
    name: z.string().optional().nullable(),
    status: brewSensorySessionStatus.optional(),
    aroma_enabled: z.boolean().optional(),
    taste_enabled: z.boolean().optional(),
    reference_brew_batch_id: brewBatchId.optional().nullable(),
    reference_brew_sample_id: brewSampleId.optional().nullable(),
    planned_date: z.date().optional().nullable(),
    instructions: z.string().optional().nullable(),
    activated_at: z.date().optional().nullable(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    source_template_id: brewSensoryTemplateId.optional().nullable(),
    aroma_form_id: brewSensoryFormId.optional().nullable(),
    taste_form_id: brewSensoryFormId.optional().nullable(),
});
export const brewSensorySessionMutator = z.object({
    id: brewSensorySessionId.optional(),
    name: z.string().optional().nullable(),
    status: brewSensorySessionStatus.optional(),
    aroma_enabled: z.boolean().optional(),
    taste_enabled: z.boolean().optional(),
    reference_brew_batch_id: brewBatchId.optional().nullable(),
    reference_brew_sample_id: brewSampleId.optional().nullable(),
    planned_date: z.date().optional().nullable(),
    instructions: z.string().optional().nullable(),
    activated_at: z.date().optional().nullable(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    source_template_id: brewSensoryTemplateId.optional().nullable(),
    aroma_form_id: brewSensoryFormId.optional().nullable(),
    taste_form_id: brewSensoryFormId.optional().nullable(),
});
//# sourceMappingURL=BrewSensorySession.js.map